/*
export default {
  grupos: (state: any) => state.grupos,
  loading: (state: any) => state.loading,
}
*/
import { Getters } from "vuex-smart-module"
import GruposState from "./state"

export default class GruposGetters extends Getters<GruposState> {

  get grupos() {
    return this.state.grupos
  }

  get loading() {
    return this.state.loading
  }
}